import React, { memo } from 'react'

// Skeleton loading
import Skeleton from 'react-loading-skeleton';

function LoadingSkeleton() {
    return (
        <React.Fragment>
            <div style={{ marginBottom: 0.5 }}>
                <Skeleton count={1} height={54} width={"100%"} />
            </div>
            <div style={{ marginBottom: 0.5 }}>
                <Skeleton count={1} height={54} width={"100%"} />
            </div>
        </React.Fragment>
    )
}

export default memo(LoadingSkeleton)